/* eslint-disable import/first */
import React from 'react';
import ClassNames from 'classnames';

import css from './index.module.scss';

export default function OrderModeButton({ imgSrc, title = '', className = '', isSelected }) {
  return (
    <div
      className={ClassNames(css.root, className, {
        [css.selectedButton]: isSelected ? true : false,
      })}
    >
      <img width="40" height="32" src={imgSrc} alt={title} title={title} />
    </div>
  );
}
